import { Field, ObjectType } from 'type-graphql'

/**
 * The result of creating a link: the raw token, shown once, and its expiry. Not persisted —
 * only the token hash is stored.
 */
@ObjectType()
export class DocumentLinkCreated {
  @Field(() => String)
  token: string

  @Field(() => Date)
  expiresAt: Date
}
